import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs/operators';


@Component({
  selector: 'app-suggestion-input',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './suggestion-input.component.html',
  styleUrls: ['./suggestion-input.component.css']
})
export class SuggestionInputComponent implements OnInit, OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['initValueId'] && changes['initValueId'].currentValue > 0 &&changes['items'].currentValue!=null) {
      console.log("Init value:", this.initValueId);
      this.setValueById(changes['initValueId'].currentValue);
    }
  }
  @Input() control: any;

  @Input() fontawesomeLabelIcon: string;
  @Input() fontawesomeButtonIcon: string;
  @Input() showButton: boolean = false;
  @Input() initValueId: number = 0;

  @Input()
  items: Suggestion[] = [];
  filteredItems: Suggestion[] = [];

  @Output()
  onSelected = new EventEmitter<Suggestion>();

  @Output()
  onValueIncorrect = new EventEmitter<boolean>();

  @Output()
  onValueEmpty = new EventEmitter<boolean>();
  empty: boolean = false;

  @Output()
  onClickButton = new EventEmitter<boolean>();


  itemSelected:Suggestion;

  ngOnInit() {
    this.control?.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe(value => {
        this.control.setValue(value);
        this.filterItems();
      });
  }

  setValueById(id: number) {
  
    const foundItem = this.items?.find(item => item.id === id);
    if (foundItem) {
      this.control.setValue(foundItem.value);
      this.filteredItems = [];
      this.onSelected.emit(foundItem);
    }
  }
  
  filterItems() {
    const maxSuggestions = 5;
    const searchTerm = this.control?.value ? this.control?.value?.toLowerCase() : '';

    if(this.items){
      this.filteredItems = this.items
      .filter(item => item.value.toLowerCase().includes(searchTerm))
      .slice(0, maxSuggestions);
    }
  }

  onItemClick(item: Suggestion) {
    this.itemSelected=item;
    this.control.setValue(item.value);
    this.filteredItems = [];
    this.onSelected.emit(item);
  }
  clickButtonAction() {
    this.onClickButton.emit(true);
  }
  observerKey(event: any) {
  
    console.log("Valor seleccionado:", this.itemSelected?.value);
    if (this.itemSelected?.value.length <= 0) {
      console.log("Está vacío");
      this.onValueEmpty.emit(true);
      this.empty = true;
    } else if (this.items.some(item => item.value.toLowerCase() === this.itemSelected?.value.toLowerCase())) {
      console.log("El valor es igual a uno de los disponibles");
    } else {
      console.log("El valor es distinto a los disponibles");
      this.onValueIncorrect.emit(true);
    }
  }

  public static convertJsonASuggestion(jsonArray: any[], columns: string[]): Suggestion[] {
    return jsonArray.map((item) => {
      // Concatenar campos según las columnas proporcionadas
      const concatenatedFields = columns
        .map((columnName) => item[columnName]) // Obtener el valor de cada columna
        .filter((field) => field !== undefined) // Filtrar los campos undefined
        .join(' '); // Unir los campos con un espacio en blanco

      // Crear un nuevo objeto con la estructura de la interfaz
      const suggestion: Suggestion = {
        id: item.id,
        value: concatenatedFields.trim().toUpperCase(), // Eliminar posibles espacios en blanco al principio o al final
      };

      return suggestion;
    });
  }
}
export interface Suggestion {
  id?: number;
  value: string;
}
